import { Component, Input } from "@angular/core";
import { ErrorStateMatcher } from "@angular/material/core";

import { DffErrorStateMatcher, IFormArray } from "@dffedb/forms";
import { EjendomsfaktorDefinition } from "@e-forsyning/common/ejendomsfaktor/model/ejendomsfaktor-definition.model";
import { Ejendomsfaktor } from "@e-forsyning/common/ejendomsfaktor/model/ejendomsfaktor.model";
import { EjendomsfaktorComponent } from "../../../ejendomsfaktor/ejendomsfaktor/ejendomsfaktor.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

@Component({
    selector: "tilslutningsanmodning-step-ejendomsfaktorer",
    templateUrl: "./step-ejendomsfaktorer.component.html",
    styleUrls: ["./step-ejendomsfaktorer.component.scss"],
    providers: [{ provide: ErrorStateMatcher, useClass: DffErrorStateMatcher }],
    imports: [EjendomsfaktorComponent, FormsModule, ReactiveFormsModule]
})
export class TilslutningsanmodningStepEjendomsfaktorerComponent {
    @Input() public ejendomsfaktorDefinitioner: EjendomsfaktorDefinition[];
    @Input() public formArray: IFormArray<Ejendomsfaktor>;
}
